import { TransakPrice } from '@cakedefi/cake-sdk';
import { isPositiveAndNotZeroNumber, localizeBigNumber } from '../../../../utils';

export const getTransakSpotPrice = (price: TransakPrice): any => (isPositiveAndNotZeroNumber(price?.conversionPrice)
  ? localizeBigNumber(1 / price?.conversionPrice, false, 2)
  : 0);
